export default "__VITE_ASSET__BWlIFkyF__"